// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"2c942e51","274":"ed33cc70","508":"35030513"}[chunkId] + ".chunk.js";
};